<template>
  <div class="collection-card-container">
    <div class="collection-card-list">
      <div
        :id="'card_'+key"
        class="collection-line column-xs row-md"
        v-for="(card, key) in getCard" :key="'card_'+key"
      >
        <div class="form-field line-align-top">
          <span>{{key+1}}</span>
        </div>
        <div class="form-field">
          <label>{{$_('card_or_gencode')}}</label>
          <Input
            :type="'text'"
            @keydown.enter.stop.prevent="vAddCollectionCard()"
            @typing="vCountNumber($event, key)"
            :val="getCard[key].tgenc"
            :ref="`code`"
          />
        </div> 
        <div class="form-field">
          <label>{{$_('quantity')}}</label>
          <Input
            :type="'number'"
            @typing="vSetStoreCard('tqte', key, card.tqte)"
            @keydown.enter.stop.prevent="vAddCollectionCard()"
            :val="getCard[key].tqte"
          />
        </div>
        <div class="form-field line-align-top">
          <span class="btn-control-quantity" @click="vSetStoreCard('tqte', key, card.tqte+1)">+</span>
        </div>
        <div class="form-field line-align-top">
          <span
            class="btn-control-quantity"
            @click="card.tqte > 1 ? vSetStoreCard('tqte', key, card.tqte-1) : vDeleteLine(key)"
          >-</span>
        </div>
        <div class="checkbox-container">
          <div class="form-field">
            <input
              type="checkbox"
              class="checkbox"
              :id="'top_gratuit_'+key"
              :checked="getGrat"
              @change="vSetStoreCard('ttop_grat', key, $event.target.checked === true ? 1 : 0)"
            />
            <label :for="'top_gratuit_'+key">{{$_('free')}}</label>
          </div>
          <div class="form-field">
            <input
              type="checkbox"
              class="checkbox"
              :id="'top_electro_'+key"
              :checked="getElectro"
              @change="vSetStoreCard('telectro', key, $event.target.checked === true ? 1 : 0)"
            />
            <label :for="'top_electro_'+key">{{$_('electronic_card')}}</label>
          </div>
        </div>
        <div class="form-field line-align-top" v-if="getCard.length > 1">
          <span class="trash-line" @click="vDeleteLine(key)">
            <img src="@/modules/produit/assets/img/trash.png" />
          </span>
        </div>
        <div class="line-amount">
          <div class="form-field">
            <small>{{$_('amount')}} : {{getLineData[key] !== undefined ? getLineData[key].line_pmontant : ''}} {{ getLineData[key] !== undefined ? getLineData[key].line_pcdev: ''}}</small>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-add-list">
      <span @click="vAddCollectionCard">+ {{$_('add_card')}}</span>
    </div>
  </div>
</template>

<script>

import echantillonService from "@/modules/produit/services/echantillonService";
import productService from '@/modules/produit/services/productService';

import Input from "@/common/components/widget/Input/Input";

export default {
  name: 'FormCard',
  data() {
    return {
      timeout_id: 0,
      line: [],
    }
  },
  components: {
    Input
  },
  created() {
    if(this.getCard.length === 0) {
      this.vAddCollectionCard()
    }
  },
  computed: {
    getCard() {
      return this.$store.getters['echantillon/get_card'];
    },
    getGrat() {
      return this.$store.getters['echantillon/get_ttop_grat'];
    },
    getElectro() {
      return this.$store.getters['echantillon/get_telectro'];
    },
    getLineData() {
      return this.line;
    }
  },
  methods: {
    focusInput() {
      this.$refs.code[this.$refs.code.length-1].$el.childNodes[0].focus();
    },
    vSetStoreCard(key, line, value) {
      if(key === 'tqte') {
        this.getMod(this.getCard[line].tgenc, line);
      }
      this.$store.dispatch('echantillon/SET_CARD_LINE', {key, line, value})
    },
    vAddCollectionCard() {
      this.$store.dispatch('echantillon/SET_CARD', {
        tmod: "",
        topt: "",
        ttail1: "",
        ttail2: "",
        tcol: 0,
        tmarq: "",
        tqte: 1,
        ttop_grat: this.getGrat,
        telectro: this.getElectro,
        tgenc: "",
        tds: "",
        tmailds: ""
      });

      this.$nextTick(() => {
        this.focusInput();
      })
    },
    getMod(val, key) {
      echantillonService.getMod(val).then(res => {
        if (res.data.DS_O.OUT.TMOD !== "") {
          this.vSetStoreCard('tgenc', key, res.data.DS_O.OUT.TMOD)
          this.getPrice(res.data.DS_O.OUT, key);
        }
      });
    },
    getPrice(data, key) {

      productService.getPriceInfo({
        pmod: data.TMOD,
        popt:  data.TOPT,
        ptail1:  data.TTAIL1,
        ptail2:  data.TTAIL2,
        pcol:  data.TCOL,
        pmarq:  data.TMARQ,
        pqte: this.getCard[key].tqte
      }).then(res => {
        if (res.data !== undefined) {
          this.line[key] = ''
          this.$set(this.line, key, {line_pmontant: res.data.PMONTANT, line_pcdev: res.data.PCDEV})
        }
      });  
    },
    vDeleteLine(key) {
      this.$store.dispatch('echantillon/DELETE_CARD_LINE', key);
    },
    vCountNumber(value, key) {

      this.vSetStoreCard('tgenc', key, value.toUpperCase());

      clearTimeout(this.timeout_id);

      if (value.length >= 4) {
        this.timeout_id = setTimeout(() => {
          echantillonService
            .getGenCode(value)
            .then(res => {
              if (res.data.DS_O.OUT.PMOD !== "") {
                this.vSetStoreCard('tgenc', key, res.data.DS_O.OUT.PMOD)
                this.getMod(res.data.DS_O.OUT.PMOD, key)
              } else {
                this.getMod(value, key)
              }     
            })
            .catch( err => {
              console.error(err);
            });

          if (
            this.getCard[this.getCard.length - 1] === undefined || this.getCard[this.getCard.length - 1].tgenc !== "") {
            this.vAddCollectionCard();
          }
        }, 1000);
      }
    }
  },
};
</script>

<style scoped>
.collection-card-list {
  background-color: #f5f5f5;
  padding: 20px;
}
.collection-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.form-field {
  padding: 0px 10px;
  display: flex;
  margin-bottom: 0px;
}
.trash-line {
  border: solid 1px #61424d;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.trash-line:hover {
  cursor: pointer;
}
.trash-line img {
  width: 20px;
}
.checkbox-container {
  display: flex;
}
.line-amount {
  display: flex;
  flex-basis: 100%;
  padding-left: 30px;
}
.line-amount small {
  font-family: 'Lato-Regular';
  font-size: var(--fz-sm);
  margin: 8px 0px 20px 0px;
}
.btn-control-quantity:hover {
  cursor: pointer
}
@media screen  and (max-width: 800px) {
  .checkbox-container {
    flex-direction: column;
  }
  .collection-line:not(:last-child) {
    border-bottom: solid 1px #bfbfbf;
    margin-bottom: 20px;
  }
  .trash-line {
    margin: 15px auto;
  }
  .line-amount {
    padding: 0px
  }
  .btn-control-quantity {
    text-align: center;
    font-size: 1.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #b8b8b8;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin: 10px auto;
  }
}
</style>